import { formatPhoneNumber } from '../../../../helpers/formatPhoneNumber';

const normalizeApplicantPhone = (phoneNumber) => {
  const formattedPhoneNumber = formatPhoneNumber({
    phoneNumber: String(phoneNumber || ''),
  })?.slice(0, 10);

  return /^\d+$/.test(formattedPhoneNumber) ? formattedPhoneNumber : undefined;
};

export default normalizeApplicantPhone;
